import { request } from "./ApiService";

export const getContacts = () => request("contacts");
